module.exports = __webpack_public_path__ + "static/media/information.c342b112.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/information.svg
// module id = 346
// module chunks = 0